import { createAction, props } from '@ngrx/store'
import { RafflePurchasesEntity } from './raffle-purchases.models'
import { HttpErrorResponse } from '@angular/common/http'

export const loadRafflePurchases = createAction('[RafflePurchases/API] Load Raffle Purchases')

export const loadRafflePurchasesSuccess = createAction(
  '[RafflePurchases/API] Load RafflePurchases Success',
  props<{ rafflePurchases: RafflePurchasesEntity[] }>(),
)

export const loadRafflePurchasesFailure = createAction(
  '[RafflePurchases/API] Load RafflePurchases Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const loadSelectedRafflePurchases = createAction('[RafflePurchases/API] Load Selected Raffle Purchases')

export const loadSelectedRafflePurchasesSuccess = createAction(
  '[RafflePurchases/API] Load Selected Raffle Purchases Success',
  props<{ rafflePurchases: RafflePurchasesEntity[] }>(),
)

export const loadSelectedRafflePurchasesFailure = createAction(
  '[RafflePurchases/API] Load Selected Raffle Purchases Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const openRafflePurchasesDialog = createAction(
  '[RafflePurchases/Page] Open Raffle Purchases Dialog',
  props<{ uuid: string }>(),
)

export const updateSelectedRafflePurchase = createAction(
  '[EventTickets/Page] Update Selected Raffle Purchase',
  props<{ uuid: string }>(),
)

export const clearSelectedRafflePurchase = createAction('[EventTickets/Page] Clear Selected Raffle Purchase')

export const clearRafflePurchases = createAction('[RafflePurchases/Page] Clear Raffle Purchases')
